import { isNextCuePreviewTarget, type LiveNextCueTarget } from '@/helpers/resolve-next-cue-preview-row.helper';
import {
  resolveSimulationSegmentPlayPointer,
  segmentKindToAnchor,
  simulationPlaylistContextFromRow,
  type FlowControlSegmentKind,
} from '@/helpers/simulation-cue-engine.helper';
import type { SimulationCueSheetRow } from '@/types/player/simulation-cue-sheet.types';

export type SegmentNextCueTarget =
  | LiveNextCueTarget
  | Pick<SimulationCueSheetRow, 'itemId' | 'scope' | 'slotId' | 'cueItemId'>
  | null
  | undefined;

/** First auto-cue row that Play segment would take. */
export function resolveSegmentFirstPlayRow(
  rows: SimulationCueSheetRow[],
  segmentKind: FlowControlSegmentKind,
  slotId?: string,
): SimulationCueSheetRow | null {
  const pointer = resolveSimulationSegmentPlayPointer(rows, segmentKindToAnchor(segmentKind), slotId, segmentKind);
  if (pointer < 0) {
    return null;
  }
  return rows[pointer] ?? null;
}

/** Same skip-confirm rule as playing an item: first section row is already Next. */
export function isSegmentFirstItemNextCue(
  rows: SimulationCueSheetRow[],
  segmentKind: FlowControlSegmentKind,
  slotId: string | undefined,
  nextTarget: SegmentNextCueTarget,
): boolean {
  const first = resolveSegmentFirstPlayRow(rows, segmentKind, slotId);
  if (!first) {
    return false;
  }
  return isNextCuePreviewTarget(nextTarget, first.itemId, simulationPlaylistContextFromRow(first));
}
